export enum AppRoutings {
  Root = "/",
  NotFound = "/*",
  RequestSuccess = "/request-success",
  ResetPassword = "/account/reset-password",
  CreateAccount = "/account/create-account/:email/:caseId",
  AccessDenied = "/access-denied",
  CreateRequest = "/request",
  PatientRequest = "/request/patient",
  FamilyFriendRequest = "/request/family-friend",
  ConciergeRequest = "/request/concierge",
  BusinessRequest = "/request/business",
  Dashboard = "/dashboard",
  ViewDocuments = "/dashboard/document/:requestId",
  CreateNewRequest = "/dashboard/create-new-request",
  Chat = "/chat",
  Profile = "/profile",
  ReviewAgreement = "/Request/ReviewAgreement/:data",
  TrackProvider = "/dashboard/track-provider/:requestId",
  TermsAndConditions = "/TermsandConditions",
}
